import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetPushToCardWorkerRequestSchema,
  TGetPushToCardWorkerResponseSchema,
} from "./getPushToCardWorker.schema";

export const getPushToCardWorker =
  (axios: IAxiosInstance) =>
  async (params: TGetPushToCardWorkerRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetPushToCardWorkerResponseSchema>
    >(`/api/push-to-card/worker`, { params });
    return response.data;
  };
